export const COMPLETE_STATUSES = ["APPROVED", "WAIVED", "NOT_APPLICABLE"];
